import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Button from '@Components/Button';
import DialogsWithIcon from '../DialogsWithIcon';

import './DialogWithConfirmationLayout.scss';

export default function DialogWithConfirmationLayout(props) {
  const {
    character,
    children,
    selfClose,
    onYesClick,
    footerClassName,
    cancelLabel = 'Cancel',
    yesLabel = 'Yes',
    content,
    layoutType,
  } = props;

  const clickYesHandler = () => {
    selfClose();
    if (onYesClick) {
      onYesClick();
    }
  };

  return (
    <DialogsWithIcon
      {...props}
      character={character}
      layoutType={layoutType}
      headerClassName="dialog-with-confirmation-layout-header"
      footerClassName={classnames(footerClassName, 'dialog-with-confirmation-layout-footer-wrapper')}
      footer={
        <div className="els-btn-group-right">
          <Button
            buttonConfig={{ type: 'primary', size: 'sm', label: cancelLabel, e2eName: 'dialog-cancel' }}
            iconConfig={{ name: 'delete', size: 'tiny', position: 'before' }}
            onClick={selfClose}
          />
          <Button
            buttonConfig={{ type: 'primary', size: 'sm', label: yesLabel, e2eName: 'dialog-yes' }}
            iconConfig={{ name: 'chevron-right', size: 'tiny' }}
            onClick={clickYesHandler}
          />
        </div>
      }>
      {children || content}
    </DialogsWithIcon>
  );
}

DialogWithConfirmationLayout.defaultProps = {
  character: '!',
};

DialogWithConfirmationLayout.propTypes = {
  selfClose: PropTypes.func.isRequired,
  onYesClick: PropTypes.func.isRequired,
  character: PropTypes.string,
  children: PropTypes.node,
  layoutType: PropTypes.string,
  footerClassName: PropTypes.string,
  cancelLabel: PropTypes.string,
  yesLabel: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};
